
<template>
  <div>
    <BandhooNavbar></BandhooNavbar>
    <PageTopImage :image-path="imagePath" top-image-heading="Privacy Policy" top-image-description="">
    </PageTopImage>
    <div class="roleContainer">
      <section class="main">
        <h1>Privacy Policy (Bandhoo)</h1>
        <ol>
          <li>This app does not share personal information with third parties, unless it is required to service your request.</li>
          <li>We do not store any information about your use of this app other than to analyze and optimize your content and user experience.</li>
          <li>We are not responsible for content originally shared by you, republished without our permission.</li>
        </ol>
        <p>This privacy policy is subject to change without notice and was last updated on Jan 24, 2020.</p>
        <p>For any questions, send email to: <a href="mailto:info@bandhoo.com">info@bandhoo.com</a></p>
      </section>
    </div>
    <BandhooFooter></BandhooFooter>
  </div>
</template>
    
<script>
import BandhooNavbar from "@/components/Nav.vue"
import BandhooFooter from "@/components/Footer.vue"
import PageTopImage from "@/components/PageTopImage.vue"

export default {
  name: 'TermsAndConditionsPage',
  data() {
    return {
      imagePath: "ptt_about.jpg",
    }
  },
  components: {
    BandhooNavbar,
    BandhooFooter,
    PageTopImage,
  }
}
</script>
    
<style scoped>
.roleContainer {
  padding: 50px;
  background-color: white;
  color: rgb(75, 75, 75);
}

p,
li {
  font-size: .9rem;
}

.main p {
  font-weight: 600;
  margin-top: 16px;
}

.main ol {
  margin-left: 16px;
}

.main a {
  color: rgb(75, 75, 75);
}

.main a:hover {
  color: rgb(109, 179, 4);
}

h1 {
  font-size: 2rem;
  margin: 16px 0;
}
@media screen and (max-width: 550px) {
  .roleContainer {
    padding: 24px;
  }

}

@media screen and (max-width: 730px) and (min-width:550px) {
  .roleContainer {
    padding: 24px;
  }

}</style>
    
    